import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import { useNavigate } from "react-router-dom";
import { TbSchool, TbPuzzle2 } from "react-icons/tb";
import DegreeList from "./DegreeList";
import { useSelector, useDispatch } from "react-redux";
import { fetchDegreeNames, fetchDegrees } from "../../redux/actions/degreeActions";
import PageComponent from "../../Components/PageComponent";

function AllDegree() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const degreenames = useSelector((state) => state.degree.degrees.data) || [];
  const degrees = useSelector((state) => state.degree.degrees?.data) || [];

  const [formData, setFormData] = useState({
    name: "",
    type: "",
    university: "",
  });

  const [filteredDegrees, setFilteredDegrees] = useState([]);

  useEffect(() => {
    dispatch(fetchDegreeNames());
    dispatch(fetchDegrees());
  }, [dispatch]);

  useEffect(() => {
    const filtered = degrees.filter((deg) => {
      const matchesName =
        !formData.name || deg.program_name === formData.name;
      const matchesType =
        !formData.type || deg.degree_type === formData.type;
      const matchesUniversity =
        !formData.university ||
        deg.offering_university
          ?.toLowerCase()
          .includes(formData.university.toLowerCase());
      return matchesName && matchesType && matchesUniversity;
    });
    setFilteredDegrees(filtered);
  }, [formData, degrees]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>

<PageComponent>
    <div className="flex w-screen h-screen bg-[#F8F7FA] overflow-x-hidden">
   
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>
      <div className="flex-1 min-h-screen p-6 ml-64 overflow-auto">
        {/* Page Title */}
        <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span>Academics & International</span>
          <span>/</span>
          <span className="text-black">Degree Management</span>
        </div>

        {/* Buttons */}
        <div className="flex items-center mt-4 space-x-4">
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() =>
              navigate("/academics&international/degreeManagement/addDegree")
            }
          >
            <TbSchool className="mr-2" />
            Add Degree Program
          </button>
          <button
            className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
            onClick={() =>
              navigate("/academics&international/degreeManagement/allDegree")
            }
          >
            <TbPuzzle2 className="mr-2" />
            All Degree
          </button>
        </div>

        {/* Filter Form */}
        <div className="w-full p-6 mt-6 bg-white rounded-lg shadow-md">
          <h2 className="mb-4 text-xl font-semibold text-gray-700">All Degrees</h2>
          <form>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
              <div>
                <label
                  className="block mb-1 text-sm font-medium text-gray-600"
                  htmlFor="name"
                >
                  Program Name
                </label>
                <select
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                >
                  <option value="">All Programs</option>
                  {degreenames.map((degree) => (
                    <option key={degree.id} value={degree.program_name}>
                      {degree.program_name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label
                  className="block mb-1 text-sm font-medium text-gray-600"
                  htmlFor="type"
                >
                  Type
                </label>
                <select
                  id="type"
                  name="type"
                  value={formData.type}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                >
                  <option value="">All Types</option>
                  <option value="General">General</option>
                  <option value="Honours">Honours</option>
                </select>
              </div>

              <div>
                <label
                  className="block mb-1 text-sm font-medium text-gray-600"
                  htmlFor="university"
                >
                  Offering University
                </label>
                <input
                  id="university"
                  name="university"
                  type="text"
                  value={formData.university}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>
            </div>
          </form>
        </div>

        {/* Registered Degrees Table */}
        <div className="w-full p-6 mt-6 bg-white rounded-lg shadow-md">
          <h2 className="mb-4 text-xl font-semibold text-gray-700">
            Registered Degree List
          </h2>
          <DegreeList degreesFilter={filteredDegrees} />
        </div>
      </div>
  
    </div>
    </PageComponent>
    </>
  );
}

export default AllDegree;
